export var views = {
  white: 'white',
  dark: 'dark'
};
export var viewsList = Object.values(views);
export var isKeyboardEvent = function isKeyboardEvent(event) {
  return event.key !== undefined;
};